var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('t-date-range-input',{staticClass:"ma-0 pa-1",on:{"input":function($event){return _vm.setDates()}},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }